import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { IMaskInput } from "react-imask";
import * as S from "./styled";
/**
 * Hooks
 */
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
/**
 * Components
 */
import ProgressBar from "../../../../components/ProgressBar";
import LayoutModal from "../../../LayoutModal";
import CreateAdress from "../../../../components/Modals/Address/Create";
/**
 * Inteface
*/
import { Inputs, IAgreements } from "Interfaces/ICustomer";

interface ICreate {
  isOpenModalCustomer: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
}

export default function CreateCustomer({
  isOpenModalCustomer,
  setModalClose,
  refreshFrames,
}: ICreate) {
  const {
    register,
    control,
    reset,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const [material, setMaterial] = useState<IAgreements[]>([]);
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const [customerId, setCustomerId] = useState<number | null>(null);

  const fetchData = async () => {
    try {
      const response = await apiRequest<IAgreements[]>('agreement');
      const dataResponse = response.data;
      if (dataResponse.length > 0) {
        setMaterial(dataResponse);
      }
    } catch (error) {
      console.log("Error: ", error);
    }

  };

  useEffect(() => {
    if (isOpenModalCustomer) {
      fetchData();
    }
  }, [isOpenModalCustomer]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest<Inputs>('customer', 'POST', data);
      if (response.status === 201) {
        const idCustomer = response.data.id;
        setCustomerId(idCustomer);
        refreshFrames();
        toggleModalVisibility("address");
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o usuário.");
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  if (isOpenModalCustomer) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Cliente"
        subTitle="Cadastre um novo cliente em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Próximo"

        nameIconMinimize={'Registrar Cliente'}
        setMaximizeModal={fetchData}
      >
        <S.ContentProgress>
          <ProgressBar name="Informações" active={true} />
          <ProgressBar name="Endereço" />
        </S.ContentProgress>
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nome do Usuário
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o nome"
              type="text"
              {...register("full_name", { required: true })}
            />
            {errors.full_name && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>CPF</S.Label>
              <Controller
                name="cpf"
                control={control}
                render={({ field }) => (
                  <IMaskInput
                    className='imask'
                    id="cpf"
                    mask="000.000.000-00"
                    placeholder="000.000.000-00"
                    onAccept={(value: string) => field.onChange(value)}
                    {...field}
                  />
                )}
              />
            </S.FormInput>

            <S.FormInput>
              <S.Label>RG</S.Label>
              <S.Input type="text" placeholder="0000000-0" />
            </S.FormInput>
          </S.SeparateDiv>

          <S.SeparateDiv>
            <S.FormInput className='inputLeft'>
              <S.Label>Data de Nascimento</S.Label>
              <S.Input
                type="date"
                placeholder="00/00/0000"
                {...register('birth_date')} />
            </S.FormInput>

            <S.FormInput className='inputLeft'>
              <S.Label>Celular Principal</S.Label>
              <Controller
                name="phone_primary"
                control={control}
                render={({ field }) => (
                  <IMaskInput
                    className='imask'
                    id="phone_primary"
                    mask="(00)00000-0000"
                    placeholder="(00) 00000-000"
                    {...field}
                  />
                )}
              />
            </S.FormInput>
          </S.SeparateDiv>

          <S.FormInput>
            <S.Label>E-mail</S.Label>
            <S.Input
              placeholder="exemplo@gmail.com"
              type="email"
              {...register("email")}
            />
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Convênio
              </S.Label>
              <S.Select {...register("agreement_id")}>
                <option value="" disabled selected hidden>
                  Selecione
                </option>
                {material.map((val) => {
                  return <option value={val.id}>{val.agreement}</option>;
                })}
              </S.Select>
            </S.FormInput>

            <S.FormInput>
              <S.Label>Número</S.Label>
              <S.Input type="text" placeholder="Número do convênio" />
            </S.FormInput>
          </S.SeparateDiv>
        </S.Container>

        <CreateAdress
          isOpenModalAdress={isOpenModal("address")}
          setModalClose={() => {
            toggleModalVisibility("address");
            onClose();
          }}
          idCustom={customerId}
        />
      </LayoutModal>
    );
  }
  return null;
}
